import { Stack, styled } from "@mui/material";

export const ContentContainer = styled(Stack)(({ theme }) => ({
  display: "inline",
  color: theme.palette.primary.main,
}));
